module.exports = __webpack_public_path__ + "static/img/success.bf0cfc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/testimonial/success.png
// module id = ne0L
// module chunks = 1